import React, { useContext } from "react";
import constants from "../../../constants";
import { getDataFromStorage } from "../../../util";
import ZoomStudentView from "../../Zoom/ZoomStudentView";
import AlertContext from "../../../context/AlertContext";

export default function CodingZoom() {
  const Alert = useContext(AlertContext);
  return (
    <>
      {Alert.isJoinZoom /* TODO: Zoom Integration */ ? (
        <ZoomStudentView
          testname={Alert.codeDetails.testname}
          learnerid={getDataFromStorage("learnerid")}
          zoomdata={JSON.stringify({
            lpid: Alert.codeDetails.lpId /* TODO: Zoom Integration */,
            testid:
              Alert.codeDetails.secData.testId /* TODO: Zoom Integration */,
            lpconfigid: Alert.codeDetails.lpConfigId,
            learnerid: parseInt(getDataFromStorage("learnerid")),
            libtypeid: constants.libTypeIds.CODING_CHALLENGE,
            qnid: Alert.codeDetails.qnid,
            qnno: Alert.codeDetails.topics.completedcount + 1 ?? 1,
          })}
        />
      ) : null}
    </>
  );
}
